
import {computed, ComputedRef, defineComponent, onMounted, PropType} from "vue";
import "vue3-carousel/dist/carousel.css";
import {Carousel, Navigation, Pagination, Slide} from "vue3-carousel";
import {Course, CourseTrack} from "../../../../../domain/entities/entities";
import course from "../Course.vue";
import {dispatchErrorBox} from "../../mixins";
import {RepositoryException} from "../../../../../domain/exceptions/exceptions";
import {useStore} from "vuex";

export default defineComponent({
  name: "CourseTrackFilter",

  components: { Carousel, Slide, Navigation, course, Pagination },

  props: {
    courseTrack: {
      type: Object as PropType<CourseTrack>,
      required: true,
    }
  },

  setup(props) {
    const store = useStore();
    const courses: ComputedRef<Course[]> = computed(() => store.getters["course_module/coursesByCourseTrack"])

    /** Todo: document this explaining where and how it's gonna be used. */
    const settings = {
      itemsToShow: 1,
      snapAlign: "center",
      wrapAround: false
    };

    /** Todo: explain what the heck is this. */
    const breakpoints = {
      320: {
        itemsToShow: 1.25
      },

      420: {
        itemsToShow: 1.5
      },
      470: {
        itemsToShow: 1.75
      },

      560: {
        itemsToShow: 2
      },

      630: {
        itemsToShow: 3
      },

      720: {
        itemsToShow: 3.5
      },

      820: {
        itemsToShow: 3
      },

      920: {
        itemsToShow: 3.25
      },

      1020: {
        itemsToShow: 3.5
      },

      1120: {
        itemsToShow: 4
      },

      1270: {
        itemsToShow: 5
      },

      1320: {
        itemsToShow: 6
      },
      1920: {
        itemsToShow: 7
      },
      2340: {
        itemsToShow: 9
      }
    };

    onMounted(async () => {
      await loadCourses(props.courseTrack.id);
    });

    async function loadCourses(id: number): Promise<void> {
      try {
          await store.dispatch(
              "course_module/loadCoursesOfCourseTrack",
             id
          );
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    }

    return {
      courses,
      settings,
      breakpoints
    };
  }
});
